import React from 'react'
import PropTypes from 'prop-types'

function Avatar(props) {
    const {profileImage} = props
    const style = profileImage && profileImage !== '' ? {backgroundImage: `url(${profileImage})`} : {}
    return (
      <div data-testid="avatar" className="avatar">
        <div className="profile_img" style={style} />
      </div>
    )
}

Avatar.propTypes = {
  profileImage: PropTypes.string,
}

export default Avatar
